import { render, staticRenderFns } from "./designationForm.vue?vue&type=template&id=4ba592fa&"
import script from "./designationForm.vue?vue&type=script&lang=js&"
export * from "./designationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports